import { logError, logWarning } from '@/utils/miscUtils';
import { getLogger } from '@/logging/logger';

export default async function postMarketingData(url: string, body: unknown, headers: { [key: string]: string } = {}) {
	const logger = getLogger('app');

	try {
		const bodyString = JSON.stringify(body);
		const response = await fetch(url, {
			method: 'POST',
			body: bodyString,
			headers: headers,
		});
		logger.info(`marketing-data: ${bodyString}`);

		return response;
	} catch (err) {
		logWarning(`Could not post quiz to userEvents api`);
		logger.info(`/marketing-data failed: ${(err as string) || 'unknown error'}`);
		if (err instanceof Error) {
			logError(`USER_EVENTS_URL: ${err.message}`);
		}
	}
}
